import { Shield, Lock, Eye, FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Datenschutz() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">

      <div className="relative pt-32 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-2xl mb-6">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">Datenschutzerklärung</h1>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto">
              Ihre Privatsphäre und der Schutz Ihrer Daten sind uns wichtig. Hier erfahren Sie, wie wir mit Ihren Informationen umgehen.
            </p>
          </div>
        </div>
      </div>

      <main className="flex-grow bg-gradient-to-b from-slate-50 to-white py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <button
            onClick={() => navigate('/')}
            className="mb-8 inline-flex items-center space-x-2 text-slate-700 hover:text-slate-900 font-medium transition group"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span>Zurück zur Startseite</span>
          </button>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Lock className="w-8 h-8 text-blue-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Sicher verschlüsselt</h3>
              <p className="text-sm text-slate-600">Alle Daten werden verschlüsselt übertragen</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Eye className="w-8 h-8 text-blue-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Transparent</h3>
              <p className="text-sm text-slate-600">Volle Kontrolle über Ihre Daten</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <FileText className="w-8 h-8 text-blue-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">DSGVO-konform</h3>
              <p className="text-sm text-slate-600">Nach Schweizer Datenschutzrecht</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Datenschutz auf einen Blick</h2>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Allgemeine Hinweise</h3>
              <p className="leading-relaxed">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert,
                wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
                werden können.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Datenerfassung auf dieser Website</h3>
              <h4 className="text-lg font-semibold text-slate-800 mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
              <p className="leading-relaxed">
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem
                Impressum dieser Website entnehmen.
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-slate-800 mb-2">Wie erfassen wir Ihre Daten?</h4>
              <p className="leading-relaxed mb-3">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten
                handeln, die Sie in ein Kontaktformular eingeben.
              </p>
              <p className="leading-relaxed">
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme
                erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
              </p>
            </section>

            <section>
              <h4 className="text-lg font-semibold text-slate-800 mb-2">Wofür nutzen wir Ihre Daten?</h4>
              <p className="leading-relaxed">
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten
                können zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Hosting</h2>
              <p className="leading-relaxed">
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              </p>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Externes Hosting</h3>
              <p className="leading-relaxed">
                Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden
                auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und
                Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten, die über eine
                Website generiert werden, handeln.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Datenschutz</h3>
              <p className="leading-relaxed">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre
                personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser
                Datenschutzerklärung.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Hinweis zur verantwortlichen Stelle</h3>
              <p className="leading-relaxed mb-3">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="bg-slate-100 p-6 rounded-lg">
                <p className="font-semibold">Clean & Umzug Profis AG</p>
                <p>Hintere Bahnhofstrasse 83</p>
                <p>5000 Aarau</p>
                <p className="mt-3">Telefon: 0800 700 100</p>
                <p>E-Mail: info@umzugprofis.ch</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Datenerfassung auf dieser Website</h2>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Kontaktformular</h3>
              <p className="leading-relaxed">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive
                der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen
                bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-slate-800 mb-3">Anfrage per E-Mail oder Telefon</h3>
              <p className="leading-relaxed">
                Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden
                personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und
                verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
